<template>
	<section class="promotions background-light main-content align-center">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>

		<div class="slide-row row">
			<div ref="emblaCarousel" class="embla">
				<div class="embla__container">
					<nuxt-link
						v-for="promoblock in items.slice(0, 4)"
						:key="promoblock.ID"
						:to="localePath(`/${promoblock.link}`)"
						class="slick-item columns column3 slick-item embla__slide fade-animate up"
					>
						<div class="slick-slide-content">
							<h3>{{ promoblock.header }}</h3>
							<span>
								{{ promoblock.button }}
								<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
							</span>
						</div>
						<picture>
							<source v-if="promoblock.imageWebp" :srcset="promoblock.imageWebp" type="image/webp" />
							<source :srcset="promoblock.image" />
							<img loading="lazy" :src="promoblock.image" :alt="promoblock.imageAlt" />
						</picture>
					</nuxt-link>
				</div>
			</div>
		</div>

		<div class="embla-controls">
			<div class="row">
				<div class="columns column12">
					<div
						v-for="(_, index) in 4"
						:key="index"
						class="slider-button"
						:class="{ active: selectedScrollSnap === index }"
						@click="scrollCarouselTo(index)"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import emblaCarouselVue from 'embla-carousel-vue';
import Autoplay from 'embla-carousel-autoplay';

const localePath = useLocalePath();

defineProps({
	subtitle: { type: String, default: '' },
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
});

const [emblaCarousel, emblaApi] = emblaCarouselVue({ loop: false, duration: 20 }, [Autoplay({ delay: 8000 })]);
const selectedScrollSnap = ref(0);
const scrollCarouselTo = (index) => {
	emblaApi.value.scrollTo(index);
	selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
};

onMounted(() => {
	if (!emblaApi.value) {
		return;
	}

	emblaApi.value.on('select', () => {
		selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
	});
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: $contentblock-background-color;
}

.row-header {
	max-width: 980px;
}

@media (max-width: 1080px) {
	.slick-item {
		margin: 0 1% 6%;
	}
}

@media (min-width: 681px) {
	.embla-controls {
		display: none;
	}
}

@media (max-width: 680px) {
	.embla {
		overflow: visible;
		position: relative;

		.slide-row {
			overflow: hidden;
		}
	}

	.embla-controls {
		.row {
			max-width: 100%;
			margin: 35px auto 0;
		}

		.column12 {
			padding: 0;
			display: flex;
			flex-flow: row wrap;
			justify-content: center;
		}

		.slider-button {
			width: 15px;
			height: 15px;
			border: 2px solid #5c936d;
			margin: 0 3px;
			background: none;
			outline: none;
			transition: all 0.3s ease-in-out;
			cursor: pointer;
			text-align: center;

			&:hover,
			&.active {
				background: $cta-color;
			}
		}
	}

	/* stylelint-disable */
	.embla__container {
		display: flex;
		align-items: flex-end;
	}

	.embla__slide {
		flex: 0 0 90%;
		min-width: 0;
		margin: 0 5%;
		text-align: center;
		position: relative;

		&::before {
			display: block;
			content: '';
			background: rgba(20 57 49 / 40%);
			position: absolute;
			z-index: 2;
			inset: 0;
			transition: all 0.3s ease-in-out;
		}

		&:hover {
			&::before {
				opacity: 0;
			}
		}

		img {
			height: auto;
			z-index: 1;
			position: relative;
		}
	}
	/* stylelint-enable */
}
</style>
